import { api, Meetup } from '../services/api';

export type NosubjectCalendarConflict = Meetup & {
  startDate: Date;
  endDate: Date;
};

export function findAcceptedNosubjectCalendarConflicts(
  meetups: Meetup[],
  startDate: Date,
  endDate: Date
): NosubjectCalendarConflict[] {
  if (!(endDate > startDate)) return [];

  return meetups
    .filter((meetup) => meetup.status === 'accepted')
    .map((meetup) => {
      const eventStart = new Date(meetup.proposed_at);
      const safeDuration = Math.max(1, Math.floor(meetup.duration_minutes));
      return {
        ...meetup,
        startDate: eventStart,
        endDate: new Date(eventStart.getTime() + safeDuration * 60_000),
      };
    })
    .filter((meetup) =>
      Number.isFinite(meetup.startDate.getTime())
      && meetup.startDate < endDate
      && meetup.endDate > startDate
    )
    .sort((a, b) => a.startDate.getTime() - b.startDate.getTime());
}

export async function getAcceptedNosubjectCalendarConflicts(
  token: string,
  startDate: Date,
  durationMinutes: number
): Promise<NosubjectCalendarConflict[]> {
  const safeDuration = Math.max(1, Math.floor(durationMinutes));
  const endDate = new Date(startDate.getTime() + safeDuration * 60_000);
  const meetups = await api.getMeetups(token, 'accepted');
  return findAcceptedNosubjectCalendarConflicts(meetups, startDate, endDate);
}
